import axios from "axios";

//let baseUrl = 'https://data.archettotowns.com/wp-json/52archettoapi/v1/';
//let baseUrl = 'https://data.archettotow'

//let baseUrl = 'http://localhost:8888/park-and-lake-touchscreen/public/wp-json/52parkandlakeapi/v1/';
let baseUrl =
    "http://localhost:8888/park-and-lake-touch/public/wp-json/52parkandlakeapi/v1/";
//let baseUrl = REACTVARS.apibase;
//console.log(baseUrl);

if (window.location.host === "localhost:3000") {
    baseUrl =
        "http://localhost:8888/park-and-lake-touchscreen/public/wp-json/52parkandlakeapi/v1/";
}

if (window.location.host === "staging.52beta.ca") {
    baseUrl =
        "https://staging.52beta.ca/park-and-lake-touchscreen/public/wp-json/52parkandlakeapi/v1/";
}
if (window.location.host === "touchscreen.parkandlake.com") {
    baseUrl =
        "https://touchscreen.parkandlake.com/wp-json/52parkandlakeapi/v1/";
}

function get(url, data = {}) {
    return axios({
        headers: {
            "Content-type": "application/json",
        },
        method: "get",
        url: baseUrl + url,
        params: data,
    });
}

function post(url, data = {}) {
    return axios({
        headers: {
            "Content-type": "application/json",
        },
        method: "post",
        url: baseUrl + url,
        data: data,
    });
}

function getContent() {
    return get("get-all-content");
}

function getPosts(type) {
    return get("getposts", { type: type });
}

function getFloorplans() {
    return get("pnl-get-floorplans");
}

function submitForm(data) {
    return post("submit-form", data);
}

function sendFloorplanEmail(email, floorplans) {
    var data = {
        floorplans: floorplans,
        email: email,
    };
    return post("emailfloorplans", data);
}

export default {
    get,
    post,
    getPosts,
    submitForm,
    getFloorplans,
    getContent,
    sendFloorplanEmail,
};
